module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-card-h-9e6acad690f78b7f536b05cc83e6ccc3.webp";